import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconBagRoundLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7 9H5v10h14V9h-2v2.001a1 1 0 1 1-2 0V9H9v2.001a1 1 0 1 1-2 0V9Zm2.171-2h5.658A3.001 3.001 0 0 0 9.17 7ZM16.9 7H20a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3.1a5.002 5.002 0 0 1 9.8 0Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconBagRoundLine);
export default Memo;
